/* eslint-disable import/prefer-default-export */
import { callApiServiceCommon } from "../service-common";

const dashboardApi = process.env.REACT_APP_DASHBOARD_API;

export function* upgradePlanPackageService(data) {
  let params = {};
  if (data.checkedSales) {
    params = {
      price_name: data.plan || "BASIC",
      bundle: false,
      year_charge: false,
      apply_charge_discount: data.checkedSales,
    };
  } else {
    params = {
      price_name: data.plan || "BASIC",
      bundle: false,
      year_charge: false,
    };
  }
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/register-recurring-charge`,
    params,
  };
  return yield callApiServiceCommon(payload);
}

export function* getDataPlanService() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-data-charge`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}
